import type { MiddlewareAPI } from 'redux';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/takeUntil';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import type { ActionsObservable } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import getBoards from '../../services/boards/get/index.tsx';
import { RETRIEVE, retrieved, retrieveFailed } from '../../state/actions/boards/index.tsx';
import { getFilter } from '../../state/selectors/query/index.tsx';
import type { State, Action } from '../../state/types.tsx';
import { getServiceRequest } from './selectors.tsx';

const retrieveBoards = (action$: ActionsObservable<Action>, store: MiddlewareAPI<State>) => {
	const getDashboardsRequestAction$ = action$.ofType(RETRIEVE);

	return getDashboardsRequestAction$.mergeMap(() => {
		const state = store.getState();
		const request = getServiceRequest(state);
		const filter = getFilter(state);

		return Observable.fromPromise(getBoards(request, filter))
			.mergeMap((result) => Observable.of(retrieved(result)))
			.takeUntil(getDashboardsRequestAction$)
			.catch((error) => {
				fireErrorAnalytics({
					error,
					meta: {
						id: 'retrieveBoards',
						packageName: 'jiraBoardsMain',
						teamName: 'keystone',
					},
				});
				return Observable.of(retrieveFailed());
			});
	});
};

export default retrieveBoards;
